<template>
<div class="table-responsive-md">
  <table class="table table-striped table-sm table-hover">
    <thead>
      <tr>
        <SortableColumn :column_heading="'Investment name'" v-on:order="order" :column_name="'investment_name'" :column="sortColumn" :direction="direction"></SortableColumn>
        <SortableColumn :column_heading="'aggregates.department'" v-on:order="order" :column_name="'department'" :column="sortColumn" :direction="direction"></SortableColumn>
        <SortableColumn :column_heading="'aggregates.service_area'" v-on:order="order" :column_name="'service_area'" :column="sortColumn" :direction="direction"></SortableColumn>
        <SortableColumn :column_heading="'aggregates.investment_type'" v-on:order="order" :column_name="'investment_type'" :column="sortColumn" :direction="direction"></SortableColumn>
        <SortableColumn :column_heading="'capital cost' + budgetType" v-on:order="order" :column_name="'sum_capital_cost'" :column="sortColumn" :direction="direction"></SortableColumn>
        <SortableColumn :column_heading="'Amount funded'" v-on:order="order" :column_name="'sum_funded'" :column="sortColumn" :direction="direction"></SortableColumn>
        <th>{{ $t('Percent funded') }}</th>
        <SortableColumn :column_heading="'Class estimate'" v-on:order="order" :column_name="'class_estimate'" :column="sortColumn" :direction="direction"></SortableColumn>
        <SortableColumn :column_heading="'aggregates.spap_theme'" v-on:order="order" :column_name="'spap_theme'" :column="sortColumn" :direction="direction"></SortableColumn>
        <SortableColumn :column_heading="'aggregates.lifecycle_activity_driver'" v-on:order="order" :column_name="'lifecycle_activity_driver'" :column="sortColumn" :direction="direction"></SortableColumn>
        <SortableColumn :column_heading="'aggregates.ward'" v-on:order="order" :column_name="'ward'" :column="sortColumn" :direction="direction"></SortableColumn>
      </tr>
    </thead>
    <tbody>
      <tr @click="$emit('modal',record)" v-for="(record,index) in cleanedRecords" :key="index">
        <td>{{ record.investment_name }}{{ record.star }}</td>
        <td>{{ record.department }}</td>
        <td>{{ record.service_area }}</td>
        <td>{{ record.investment_type }}</td>
        <td>{{ record.sum_capital_cost | formatMoney }}</td>
        <td>{{ record.sum_funded | formatMoney }}</td>
        <td>{{ ((record.sum_capital_cost) ? record.sum_funded / record.sum_capital_cost : 0 ) | formatPercent }}</td>
        <td>{{ (record.class_estimate | parseInt) || "N/A" }}</td>
        <td>{{ record.spap_theme }}</td>
        <td>{{ record.lifecycle_activity_driver }}</td>
        <td>{{ record.ward }}</td>
      </tr>
    </tbody>
  </table>
  <p class="small font-italic">{{ $t('disclaimer') }}</p>
</div>
</template>

<script>
import SortableColumn from './SortableColumn.vue';

export default {
    props: ['records', 'budgetType', 'sortColumn','direction'],
    computed: {
        cleanedRecords() {
            let label =  (this.budgetType == '6yearBudget') ? 'sum_preliminary_capital_cost_6_year' : 'sum_preliminary_capital_cost_10_year';
            return this.records.map(row => {
                row.sum_capital_cost = parseInt(row.sum_funded || 0) + parseInt(row.sum_unfunded || 0);
                row.star = (label in row && row[label]) ? '*' : '';
                return row;
            });
        }
    },
    methods: {
      order(column,direction) {
        this.$emit('order',column,direction);
      }
    },

    components: { SortableColumn }
}
</script>

<style>
thead th { padding-right: 1.25rem !important; }
tbody tr { cursor: pointer; }
</style>